import React from "react";

import styled from "styled-components";

import Section from "../UserInterface/Section";
import Company from "../UserInterface/Company";
import ProjectLink from "../UserInterface/ProjectLink";
import Paragraph from "../UserInterface/Paragraph";
import ProfilePicture from "../ProfilePicture";
import SpanLink from "../UserInterface/SpanLink";

const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CompanyContainer = styled.div`
  margin: 40px 0 0 0;

  display: flex;

  flex-wrap: wrap;

  @media (max-width: 768px) {
    margin: 40px 0 0 0;
    flex-direction: column;
    flex-wrap: no-wrap;
  }
`;

const Headline = styled.h1`
  font-family: CanelaWeb;
  font-size: 56px;
  line-height: 1.3;
  letter-spacing: 0.93px;
  color: #1b2c63;
  font-weight: 400;

  margin: 32px 0 0 0;

  @media (max-width: 768px) {
    line-height: 1.25;
    font-size: 40px;
    letter-spacing: 0.67px;
  }
`;

const MainRow = styled.div`
  width: 100%;
  display: flex;
`;

const Column = styled.div`
  width: ${(props) => props.width};
  max-width: ${(props) => props.maxWidth};
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: ${(props) => (props.off ? "none" : "block")};
    width: fit-content;
    align-items: center;
  }
`;
const B = styled.span`
  font-weight: 700;
`;
const Spacer = styled.div`
  height: 100px;
`;

const Landing = (props) => {
  return (
    <Container className="test">
      <span id="about"></span>
      <Section title="ABOUT ME" spaceAbove={80}>
        <MainRow>
          <Column width="60%" maxWidth="500px">
            <Headline>Hi, I'm Wendy Chu.</Headline>
            <ProfilePicture margin={24} dimension={256} displayFor="mobile" />
            <Paragraph width="100%" maxWidth="543px">
              Staff-level product designer in Los Angeles, CA, with 14+ years of
              experience across B2B and B2C. I've previously crafted digital
              experiences at{" "}
              <SpanLink href="https://www.allbirds.com/">Allbirds</SpanLink>,{" "}
              <SpanLink href="https://www.vts.com">VTS</SpanLink>,{" "}
              <SpanLink href="https://www.primary.com">Primary</SpanLink>, and{" "}
              <SpanLink href="https://www.ralphlauren.com/">
                Ralph Lauren
              </SpanLink>
              .{" "}
            </Paragraph>

            <Paragraph width="100%" maxWidth="543px">
              As a design practitioner, I have deep experience across the entire
              product design process. I consistently drive projects from
              strategy and ideation to execution and delivery with a bias toward
              iteration and experimentation. Product managers love that I am
              data-driven, focus on delivering user value, and naturally break
              big projects into smaller iterative phases. Engineers love that I
              collaborate with them on solutions, can speak to the technical
              side of things, and strive to improve design documentation for
              their sakes. QAs love that I do my own design QA pass. Users love
              my passion for understanding and solving their problems. Design
              managers love my drive to learn new things and improve existing
              processes and communication methods.{" "}
            </Paragraph>
            <Paragraph width="100%" maxWidth="543px">
              As a design leader, I distinguish myself through excellent
              cross-functional collaboration and communication, and by balancing
              big-picture thinking and detail-oriented design work. I have a
              knack for coaxing order out of chaos. I love tackling ambiguous
              problems and creating processes and frameworks that foster
              communication, collaboration, and inclusion.
            </Paragraph>
          </Column>
          <Column width="40%" maxWidth="400px" off={true}>
            <ProfilePicture margin={108} dimension={300} displayFor="desktop" />
          </Column>
        </MainRow>
      </Section>

      <span id="work"></span>
      <Section title="WORK" spaceAbove={48}>
        <CompanyContainer>
          <Column width="50%">
            <Company title="VTS">
              <ProjectLink
                text="Market Listing Share"
                href="https://wendychu.notion.site/VTS-Market-Listing-Sharing-24fa83b969a080509458f65937160636"
              ></ProjectLink>
              <ProjectLink
                text="Access Management"
                route="vts-access-management"
              />
              {/* <ProjectLink
              text="Mobile Access"
              route="vts-mobile-access"
            />*/}
            </Company>
            <Company title="Allbirds">
              <ProjectLink text="Product Detail Page" route="allbirds-pdp" />
            </Company>
          </Column>
          <Column width="50%">
            <Company title="Primary.com">
              <ProjectLink
                text="Navigation Redesign"
                route="primary-navigation-redesign"
              />
              <ProjectLink
                text="Product Detail Page"
                route="primary-product-detail-page"
              />
              <ProjectLink text="Design System" route="primary-style-guide" />
            </Company>
          </Column>
          {/* <Company title="Ralph Lauren">
                        <ProjectLink text="Find a Store" route="ralph-lauren-find-a-store"/>
                        <ProjectLink text="Mobile Webstore" route="ralph-lauren-mobile-webstore"/>
                    </Company> */}
        </CompanyContainer>
      </Section>

      <span id="contact"></span>
      <Section id="contact" title="CONTACT" spaceAbove={40}>
        <Paragraph width="70%">
          I’m currently looking for a full-time{" "}
          <B>senior/staff product design</B> role, preferably remote. I'd be
          most interested in: marketplaces, SaaS tools, design systems,and
          experiences that bridge digital and physical. If you think we might be
          a good fit, I'd love to chat! Get in touch with me at{" "}
          <SpanLink href="mailto:hi@wendychu.design">
            hi@wendychu.design
          </SpanLink>
          !
        </Paragraph>
      </Section>

      <Spacer />
    </Container>
  );
};

export default Landing;
